import React from 'react'
import styled from 'styled-components'

// because this component has a theme prop which conflicts
// with the theme object from styled components theme provider
import { media } from 'sidecar-design-library'

import BaseIcon from '../IconV1'
import LoadingSpinner from '../LoadingSpinnerV1'
import withProp from '../../../utils/withProp'
import themes from './themes'

export const Icon = styled(BaseIcon)`
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  right: 1.5625rem;
  font-size: 1.5625rem;
  transition: all 0.5s;
  transition: background-color 0.2s;
  opacity: 1;
  color: inherit;
`

export const MiniSpinner = styled(LoadingSpinner)`
  position: absolute;
  top: calc(50% - 0.78125rem);
  right: 1.5625rem;
  font-size: 1.5625rem;
  padding: 0;
  width: 1.5625rem;
  height: 1.5625rem;
  color: inherit;
`

export const Button = styled(
  ({
    iconText,
    iconPosition,
    busy,
    full,
    hasIcon,
    noeffects,
    smallText,
    next,
    center,
    ...safeProps
  }) => <button {...safeProps} />,
)`
  display: flex;
  justify-content: center;
  align-items: center;
  ${withProp('width')}
  border-radius: 0.3125rem;
  text-align: center;
  line-height: 1.375rem;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s;
  flex-basis: 100%;
  border: solid 1px transparent;
  user-select: none;
  font-size: 1.25rem;

  // fix for IE11 min-height with align-items:center
  // https://github.com/philipwalton/flexbugs/issues/231
  min-height: 3.125rem;
  height: 3.11875rem;

  ${p =>
    p.smallText &&
    `
    font-size: 1.125rem;
  `}

  ${p =>
    p.full &&
    `
    width: 100%;
  `}

  // this assumes that the icon is on the right
  ${p =>
    p.icon
      ? 'padding: 0 3.75rem 0 2.1875rem;'
      : 'padding: 0 2.5rem 0 2.1875rem;'}
  // this corrects the assumption and checks if icon is on the left
  ${p =>
    p.iconPosition === 'before' &&
    `
    padding: 0 2.1875rem 0 3.75rem;
  `}

  ${p =>
    p.disabled &&
    `
    cursor: default;
  `}

  ${media.mobileAndBelow`
    min-width: 100%;
  `}

  ${Icon}, ${MiniSpinner} {
    ${p =>
      p.iconPosition === 'before' &&
      `
      right: auto;
      left: 1.5625rem;
    `}
  }

  ${p => themes[p.kind]}
`

export const A = Button.withComponent(
  ({
    iconText,
    iconPosition,
    busy,
    full,
    noeffects,
    smallText,
    next,
    ...safeProps
    // eslint-disable-next-line jsx-a11y/anchor-has-content
  }) => <a {...safeProps} />,
)
A.displayName = 'A'
